import React from "react";
import ReactECharts from "echarts-for-react";

const AgeWiseStocksChart = ({ data, heading }) => {
  const chartData = Object.keys(data)
    .map((key) => ({
      name: key,
      actualValue: data[key],
      displayValue: 100,
    }))
    .reverse();

  const option = {
    title: {
      text: heading,
      left: "left",
      textStyle: {
        fontFamily: "Uni Neue",
        fontSize: 16,
        fontWeight: "600",
      },
    },
    tooltip: {
      trigger: "item",
      formatter: (params) => {
        return `${params.name}<br/>Value: ${
          chartData[params.dataIndex].actualValue
        }`;
      },
    },
    grid: {
      left: "5%",
      right: "4%",
      bottom: "3%",
      top: "25%",
      containLabel: true,
    },
    xAxis: {
      type: "value",
      max: 100,
      axisLabel: {
        show: false,
        padding: [10, 10],
      },
      splitLine: {
        show: false,
      },
      offset: 10,
    },
    yAxis: {
      type: "category",
      data: chartData.map((item) => item.name),
      axisLabel: {
        padding: [0, 10],
      },
      axisTick: {
        show: false,
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: "#000",
        },
      },
    },
    series: [
      {
        type: "bar",
        data: chartData.map((item) => item.displayValue),
        barWidth: 20,
        itemStyle: {
          color: (params) => {
            const colorList = ["#5470C6", "#EF6AE9", "#73C0DE", "#FC8452"];
            return colorList[params.dataIndex % colorList.length];
          },
          borderRadius: [10, 10, 10, 10],
        },
        label: {
          show: true,
          position: "inside",
          formatter: (params) => {
            const reversedValue = chartData[params.dataIndex].actualValue;
            return reversedValue;
          },
          fontWeight: 600,
          z: 888,
        },
      },
    ],
  };

  return (
    <div className="relative">
      <ReactECharts option={option} style={{ height: 230, width: "100%" }} />
    </div>
  );
};

export default AgeWiseStocksChart;
